
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class TawkToChatDialog extends Serenity.EntityDialog<TawkToChatRow, any> {
        protected getFormKey() { return TawkToChatForm.formKey; }
        protected getIdProperty() { return TawkToChatRow.idProperty; }
        protected getLocalTextPrefix() { return TawkToChatRow.localTextPrefix; }
        protected getNameProperty() { return TawkToChatRow.nameProperty; }
        protected getService() { return TawkToChatService.baseUrl; }
        protected getDeletePermission() { return TawkToChatRow.deletePermission; }
        protected getInsertPermission() { return TawkToChatRow.insertPermission; }
        protected getUpdatePermission() { return TawkToChatRow.updatePermission; }

        protected form = new TawkToChatForm(this.idPrefix);

    }
}